import React, { useCallback } from "react";
import styled, { css } from "styled-components";
import MessageFieldEditModeListItem from "views/components/messagelist/MessageFields/MessageFieldEditModeListItem";
import { SortableList } from "components/common";
import useFormattedFields from "views/components/messagelist/MessageFields/hooks/useFormattedFields";
const Container = styled.div(
  ({ theme }) => css`
    margin-left: ${theme.spacings.sm};
    display: flex;
    flex-direction: column;
    padding: ${theme.spacings.xs} 0;
  `
);
const ItemContainer = styled.div(
  ({ theme }) => css`
    &:not(:last-child) {
      border-bottom: 1px solid ${theme.colors.table.row.divider};
    }
    padding: ${theme.spacings.xs} ${theme.spacings.sm};
  `
);
const MessageFieldsEditModeFavoritesList = ({
  fields,
  onFavoriteToggle,
  reorderFavoriteFields
}) => {
  const customContentRender = useCallback(
    ({ item: { field, value, type } }) => /* @__PURE__ */ React.createElement(
      MessageFieldEditModeListItem,
      {
        key: field,
        fieldName: field,
        fieldType: type,
        value,
        isFavorite: true,
        onFavoriteToggle
      }
    ),
    [onFavoriteToggle]
  );
  if (!fields.length) return null;
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("h3", null, "Favorite fields"), /* @__PURE__ */ React.createElement(Container, null, /* @__PURE__ */ React.createElement(
    SortableList,
    {
      items: fields,
      onMoveItem: reorderFavoriteFields,
      displayOverlayInPortal: true,
      alignItemContent: "center",
      customContentRender
    }
  )));
};
const MessageFieldsEditModeRestList = ({ fields, onFavoriteToggle }) => {
  if (!fields.length) return null;
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("h3", null, "Remaining fields"), /* @__PURE__ */ React.createElement(Container, null, fields.map(({ field, type, value }) => /* @__PURE__ */ React.createElement(ItemContainer, { key: field }, /* @__PURE__ */ React.createElement(
    MessageFieldEditModeListItem,
    {
      fieldName: field,
      fieldType: type,
      value,
      isFavorite: false,
      onFavoriteToggle
    }
  )))));
};
const MessageFieldsEditModeLists = ({ reorderFavoriteFields, onFavoriteToggle, editingFavoriteFields }) => {
  const { formattedFavorites, formattedRest } = useFormattedFields(editingFavoriteFields);
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(
    MessageFieldsEditModeFavoritesList,
    {
      reorderFavoriteFields,
      onFavoriteToggle,
      fields: formattedFavorites
    }
  ), /* @__PURE__ */ React.createElement(MessageFieldsEditModeRestList, { onFavoriteToggle, fields: formattedRest }));
};
export default MessageFieldsEditModeLists;
